import { useLayoutEffect, useState } from 'react';

export const useClientWidth = (): number => {
	const [width, setWidth] = useState<number>(
		typeof window !== 'undefined' ? window.innerWidth : 0
	);
	useLayoutEffect(() => {
		const setMeasuredWidth = () => {
			setWidth(window.innerWidth);
		};
		window.addEventListener('resize', setMeasuredWidth);
		return () => window.removeEventListener('resize', setMeasuredWidth);
	}, []);
	return width;
};
